import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import { CreateCampaignData } from "../../../types/campaign";
import Stack from "@mui/material/Stack";
import { useCallback } from "react";
import { Sms } from "./Sms";
import { Email } from "./Email";
import { WhatsApp } from "./WhatsApp";

export function Message() {
  const formik = useFormikContext<CreateCampaignData>();

  const RenderContent = useCallback(() => {
    switch (formik.values.channel) {
      case "sms":
        return <Sms />;
      case "email":
        return <Email />;
      case "whatsapp":
        return <WhatsApp />;
    }
  }, [formik.values.channel]);

  return (
    <Stack spacing={4}>
      <Typography color="primary">Mensagem</Typography>
      {RenderContent()}
    </Stack>
  );
}
